import * as $ from 'jquery'

import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule, Routes, ExtraOptions } from '@angular/router'

import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { ToggleSwitchModule } from 'primeng/toggleswitch'
import { TextareaModule } from 'primeng/textarea'
import { MenuModule } from 'primeng/menu';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { MultiSelectModule } from 'primeng/multiselect';
import { PasswordModule } from 'primeng/password';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TagModule } from 'primeng/tag'
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { DrawerModule } from 'primeng/drawer';
import { BurtUiModule } from '@burt-ui';

import { COMPONENTS, ENTRY_COMPONENTS } from './components/components';
import { SERVICES } from './services/providers';

import { WrapMiddleDirective } from './directives/wrap-middle.directive'

import { PIPES } from './pipes/providers'

import {
  DateRangePickerModule,
  HubUrlModule,
  LocationModule,
  WindowModule
} from './modules'

import {
  EmailListValidator,
} from './validators/email-list.validator';

import { UnsavedChangesGuard } from './guards/unsaved-changes.guard'
import { SelectModule } from 'primeng/select'
import { DialogTemplateComponent } from './components/dialog-template/dialog-template.component'
import { HubTemplateSaveModalModule } from './components/template-save-modal/template-save-modal.module';
import { InputTextModule } from 'primeng/inputtext'
import { MessageModule } from 'primeng/message'

const HUB_MODULES = [
  CommonModule,
  DateRangePickerModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  BurtUiModule,
  HubUrlModule,
  LocationModule,
  WindowModule,
  SelectModule,
  DialogModule,
  ButtonModule,
  TooltipModule,
  DrawerModule,
  AvatarModule,
  PanelMenuModule,
  DividerModule,
  PanelModule,
  CardModule,
  MenuModule,
  TieredMenuModule,
  HubTemplateSaveModalModule,
  DialogTemplateComponent,
  ToggleButtonModule,
  SelectButtonModule,
  MultiSelectModule,
  TextareaModule,
  CheckboxModule,
  ToggleSwitchModule,
  InputTextModule,
  PasswordModule,
  TagModule,
  MessageModule,
]

const HUB_COMPONENTS = [
  COMPONENTS,
  EmailListValidator,
  WrapMiddleDirective
]

const HUB_PIPES = [
  PIPES
]

const HUB_SERVICES = [
  SERVICES
]

const HUB_GUARDS = [
  UnsavedChangesGuard
]

@NgModule({
  declarations: [
    HUB_COMPONENTS,
    HUB_PIPES,
  ],
  imports: [
    HUB_MODULES,
  ],
  exports: [
    HUB_MODULES,
    HUB_COMPONENTS,
    HUB_PIPES,
  ],
})
export class HubComponentsModule {
  public static forRoot(): ModuleWithProviders<HubComponentsModule> {
    return { ngModule: HubComponentsModule, providers: [HUB_SERVICES, HUB_GUARDS] };
  }
}
